import React from 'react';
import Modal from '../common/Modal';
import IconComponent from '../icons/IconComponent';
import { DocumentTextIcon, TableCellsIcon, FolderIcon, ChatBubbleBottomCenterTextIcon, GlobeAltIcon, NewspaperIcon } from '@heroicons/react/24/outline';

export default function CreateDocumentModal({ isOpen, onClose, onSelectType }) {
  const documentTypes = [
    {
      id: 'document',
      name: 'Document',
      description: 'Create a new text document',
      icon: DocumentTextIcon
    },
    {
      id: 'table',
      name: 'Table',
      description: 'Create a new data table',
      icon: TableCellsIcon
    },
    {
      id: 'folder',
      name: 'Folder',
      description: 'Create a new folder',
      icon: FolderIcon
    },
    {
      id: 'social',
      name: 'Social Post',
      description: 'Create a social media post',
      icon: ChatBubbleBottomCenterTextIcon
    },
    {
      id: 'blog',
      name: 'Blog Post',
      description: 'Create a blog post',
      icon: NewspaperIcon
    },
    {
      id: 'website',
      name: 'Website Analysis',
      description: 'Analyze a website for SEO',
      icon: GlobeAltIcon
    }
  ];

  return (
    <Modal isOpen={isOpen} onClose={onClose} title="Create New">
      <div className="grid grid-cols-2 gap-4">
        {documentTypes.map((type) => (
          <button
            key={type.id}
            onClick={() => onSelectType(type.id)}
            className="flex flex-col items-center p-6 bg-dark-200 rounded-lg hover:bg-dark-300 transition-colors text-center border border-gray-700"
          >
            <type.icon className="w-12 h-12 mb-4 text-gray-400" />
            <h3 className="font-medium">{type.name}</h3>
            <p className="text-sm text-gray-400">{type.description}</p>
          </button>
        ))}
      </div>
    </Modal>
  );
}